import { FormSchemaEntry } from '@gik/ui/Form';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/inkind-page/i18n/en';

const pageTitleFieldSetSchema = (): FormSchemaEntry[] => [
  {
    name: 'pageTitle',
    type: 'text',
    required: true,
    minLength: 2,
    maxLength: 80,
    errorName: 'Page Title',
    placeholder: i18n.t(translationKeys.pageTitlePlaceholder),
  },
];

export default pageTitleFieldSetSchema;
